module.exports = __webpack_public_path__ + "static/media/252-mexico.01c07cc3.svg";